<template>
  <zg-module v-bind="moduleProps">
    <zg-quoted-by v-bind="$props" />
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgModule from '../ZgModule/ZgModule.vue'
  import ZgQuotedBy from '../../ZgQuotedBy/ZgQuotedBy.vue'
  export default {
    name: 'ZgQuotedBySection',
    components: {
      ZgModule,
      ZgQuotedBy
    },
    mixins: [module],
    props: {
      image: {
        type: String,
        required: false,
        default: null
      },
      name: {
        type: String,
        required: true
      },
      bioLink: {
        type: String,
        required: false,
        default: null
      },
      jobTitle: {
        type: String,
        required: false,
        default: null
      },
      text: {
        type: String,
        required: false,
        default: null
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: (value) => [
          'beige',
          'secondary-500'
        ].includes(value)
      },
      trustpilotData: {
        type: Object,
        required: false,
        default: null
      },
      disclaimer: {
        type: String,
        required: false,
        default: null
      },
      direction: {
        type: String,
        required: false,
        default: 'bottom-left',
        validator: (value) => [
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right'
        ].includes(value)
      }
    }
  }
</script>
